import consumer from "./consumer";
import {UniqueChecker} from "../lib/UniqueChecker";
import {Subscription} from "@rails/actioncable";

export class VoterChannelSubscription {
  public subscription: Subscription;
  private uniqueChecker: UniqueChecker<string>;
  private readonly voterSessionUuid: string;

  constructor(voterSessionUuid: string, { received, connected = undefined, disconnected = undefined }) {
    this.uniqueChecker = new UniqueChecker<string>();
    this.voterSessionUuid = voterSessionUuid;
    this.subscription = consumer.subscriptions.create(
      {
        channel: "VoterChannel",
        voter_session_uuid: this.voterSessionUuid,
      },
      {
        received: (data) => {
          if (this.uniqueChecker.wasSeen(data.uuid))
            return console.debug("DUPLICATE MESSAGE RECEIVED: ", data);
          received(data);
        },
        connected() {
          console.debug("VoterChannel connected")
        },
        disconnected() {
          console.debug("VoterChannel disconnected")
        },
      }
    );
  }



  unsubscribe() {
    this.subscription.perform(
      "log_out",
      { voter_session_uuid: this.voterSessionUuid }
    );
    this.subscription.unsubscribe();
  }
}